import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import CardDropdown from 'components/common/CardDropdown';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import Notification from 'components/we-raise-common/Notification';
import {
  weNotificationsProject,
  weTableDataForProject
} from 'data/weraise-data/sponsored-list-data';

import React from 'react';
import { Card, Col, Dropdown, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const projectsListCounter = [
  { id: 1, title: 'Initiated', value: 8, color: 'info' },
  { id: 2, title: 'Completed', value: 6, color: 'success' },
  { id: 3, title: 'Ongoing', value: 184, color: 'warning' },
  { id: 4, title: 'Rejected', value: 1, color: 'danger' }
];

const ProjectsList = () => {
  const navigate = useNavigate();
  const columns = [
    {
      accessor: 'ref',
      Header: 'Ref',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'project',
      Header: 'Project',
      cellProps: {
        className: 'py-2 fw-medium'
      }
    },
    {
      accessor: 'country',
      Header: 'Country',
      cellProps: {
        className: 'fw-medium py-2'
      }
    },
    {
      accessor: 'manager',
      Header: 'Manager',
      cellProps: {
        className: 'fw-medium py-2'
      }
    },
    {
      accessor: 'start_date',
      Header: 'Started Date',
      cellProps: {
        className: 'fw-medium py-2'
      }
    },
    {
      accessor: 'total_funding',
      Header: 'Total Funding',
      cellProps: {
        className: 'fw-medium py-2'
      }
    },
    {
      accessor: 'status',
      Header: 'Status',
      cellProps: {
        className: 'fw-medium py-2'
      },
      Cell: rowData => {
        return (
          <SoftBadge pill bg={rowData.row.original.variant} className="me-2">
            {rowData.row.original.status}
          </SoftBadge>
        );
      }
    },
    {
      accessor: 'oid',
      Header: '',
      cellProps: {
        className: 'text-end fw-medium py-2'
      },
      disableSortBy: true,
      Cell: rowData => {
        const { id } = rowData.row;

        return (
          <CardDropdown>
            <div className="py-2">
              <Dropdown.Item as={Link} to={'/project/create_project'}>
                Project Proposal
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={`/project/${id}/progress`}>
                Project Progress
              </Dropdown.Item>
              <Dropdown.Item
                className="text-success"
                as={Link}
                to={`/project/details/${id}/complete_project`}
              >
                Complete Project
              </Dropdown.Item>
            </div>
          </CardDropdown>
        );
      }
    }
  ];

  return (
    <>
      <Row className="g-3 mb-3">
        <Col md={6}>
          <Card>
            <Card.Body className="mt-1">
              <Row className="g-3">
                {projectsListCounter?.map((item, index) => (
                  <Col className="col-6" xl={3} key={item.id}>
                    <Flex
                      className={classNames({
                        'border-xl-end':
                          index !== projectsListCounter.length - 1
                      })}
                    >
                      <FontAwesomeIcon
                        icon={'circle'}
                        className={`text-${item.color} fs--2 mt-1`}
                      />
                      <div className="ms-2">
                        <p className="mb-2 fw-medium">{item.title}</p>
                        <p className="mb-0 fs-2 fw-medium">{item.value}</p>
                      </div>
                    </Flex>
                  </Col>
                ))}
              </Row>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="overflow-hidden">
            <Card.Body className="p-0">
              <ul className="mb-0 list-unstyled">
                {weNotificationsProject.map((notification, index) => (
                  <Notification
                    key={notification.id}
                    notification={notification}
                    isLast={weNotificationsProject.length - 1 === index}
                  />
                ))}
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={12} xxl={12} className="h-md-100">
          <CustomAdvanceTable
            data={weTableDataForProject}
            columns={columns}
            perPage={10}
            showTablePagination
            title="Projects"
            showSearchInput
            searchInputPlaceHolder="Search"
            addButtonIcon="project-diagram"
            addButtonLabel="Create Project"
            onClickAddNew={() => navigate('/project/create_project')}
          />
        </Col>
      </Row>
    </>
  );
};

export default ProjectsList;
